import { render, staticRenderFns } from "./EconomicCalendar.vue?vue&type=template&id=3091d0f4&scoped=true&"
import script from "./EconomicCalendar.vue?vue&type=script&lang=js&"
export * from "./EconomicCalendar.vue?vue&type=script&lang=js&"
import style0 from "./EconomicCalendar.vue?vue&type=style&index=0&id=3091d0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3091d0f4",
  null
  
)

export default component.exports